import RouterPlombier from "./components/Router/Router";
import "./App.css";

function App() {
  return <RouterPlombier />;
}

export default App;
